import { render, staticRenderFns } from "./GamesView.vue?vue&type=template&id=45885bc2&scoped=true&"
import script from "./GamesView.vue?vue&type=script&lang=js&"
export * from "./GamesView.vue?vue&type=script&lang=js&"
import style0 from "./GamesView.vue?vue&type=style&index=0&id=45885bc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45885bc2",
  null
  
)

export default component.exports